// removed by extract-text-webpack-plugin
module.exports = {"container":"container___3a82w","wrapper":"wrapper___2o9cO","logo":"logo___B7hor","info":"info___215TP","modal":"modal___2jhB_","header":"header___3Ync8","body":"body___OWp56","close":"close___q7F3G","overlay":"overlay___2Aw7d","hidden":"hidden___wJ-DM","left":"left___1e_8I"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Navigation.scss
// module id = 20
// module chunks = 0